import { render, staticRenderFns } from "./DepartmentCreateModal.vue?vue&type=template&id=ef074da4&scoped=true"
import script from "./DepartmentCreateModal.vue?vue&type=script&lang=js"
export * from "./DepartmentCreateModal.vue?vue&type=script&lang=js"
import style0 from "./DepartmentCreateModal.vue?vue&type=style&index=0&id=ef074da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef074da4",
  null
  
)

export default component.exports